import { Injectable } from '@angular/core';

import { FlowchartLinkDto, LinkAnchor } from '@treetop/shared/model';

import { LinkAnchorData } from '../operations/operations.service';

@Injectable({
  providedIn: 'root',
})
export class ConverterService {
  convertFlowchartLinkToLinkDto(
    sourceElementId: string,
    targetElementId: string,
    sourceAnchor: LinkAnchorData,
    targetAnchor: LinkAnchorData,
    linkId: string,
  ): FlowchartLinkDto | undefined {
    if (!linkId) {
      return undefined;
    }

    if (!sourceElementId) {
      return undefined;
    }

    const link = this.createLinkDto(sourceElementId, targetElementId, linkId);
    link.fromFlowchartNodeAnchor = this.getAnchorNumber(sourceAnchor?.name);
    link.toFlowchartNodeAnchor = this.getAnchorNumber(targetAnchor?.name);

    return link;
  }

  private createLinkDto(sourceElementId: string, targetElementId: string, linkId: string): FlowchartLinkDto {
    return {
      id: linkId,
      fromFlowchartNodeId: sourceElementId,
      toFlowchartNodeId: targetElementId,
      linkOffset: null,
      attribute: null,
      elementType: 5,
      relationshipType: 1,
    };
  }

  public recreateNewLinkDto(sourceAnchor: LinkAnchor, targetAnchor: LinkAnchor, linkId, linkSourceId, linkTargetId): FlowchartLinkDto {
    return {
      id: linkId,
      fromFlowchartNodeId: linkSourceId,
      fromFlowchartNodeAnchor: sourceAnchor,
      toFlowchartNodeId: linkTargetId,
      toFlowchartNodeAnchor: targetAnchor,
      linkOffset: null,
      attribute: null,
      elementType: 5,
      relationshipType: 1,
    };
  }

  getAnchorNumber(anchor: string): LinkAnchor {
    switch (anchor) {
      case 'top':
        return 0;
      case 'bottom':
        return 1;
      case 'left':
        return 2;
      default:
        return 3;
    }
  }

  getAnchorName(anchor: LinkAnchor): LinkAnchorData {
    switch (anchor) {
      case LinkAnchor.Top:
        return { name: 'top' };
      case LinkAnchor.Bottom:
        return { name: 'bottom' };
      case LinkAnchor.Left:
        return { name: 'left' };
      default:
        return { name: 'right' };
    }
  }
}
